import React from "react";
import { Routes, Route } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";
import ListAgentMarginDetails from "../Components/Agent Margin Details/listAgentMarginDetails";
import ViewAgentMarginDetails from "../Components/Agent Margin Details/viewAgentMarginDetails";

const AgentMarginDetailsRoutes = () => {
//   const { admin } = useSelector((state) => state.admin || {});
// //   const accessCode = admin?.data?.access_code || [];

//   const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
//   const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  return (
    <Routes>
      <Route
        path="/agent_margin_details"
        element={<ListAgentMarginDetails />}
      />
      <Route
        path="/agent_margin_details/view/:id"
        element={<ViewAgentMarginDetails />}
      />
    </Routes>
  );
};

export default AgentMarginDetailsRoutes;